import {useEffect, useState} from 'react';
import {automaticMode} from './publicTheme';

export default function useGalleryTheme() {
    const [preference, setPreference] = useState(() => {
        try { const value = localStorage.getItem('arta-theme'); return ['light', 'dark', 'auto'].includes(value) ? value : 'auto'; }
        catch { return 'auto'; }
    });
    const [clockMode, setClockMode] = useState(automaticMode);
    useEffect(() => {
        const update = () => setClockMode(automaticMode());
        const timer = setInterval(update, 30000);
        window.addEventListener('focus', update);
        return () => { clearInterval(timer); window.removeEventListener('focus', update); };
    }, []);
    const chooseTheme = (value) => {
        setPreference(value);
        setClockMode(automaticMode());
        try { localStorage.setItem('arta-theme', value); } catch { /* Storage may be unavailable. */ }
    };
    return {preference, chooseTheme, mode: preference === 'auto' ? clockMode : preference};
}
